
<ul>
    <li><a [routerLink]="['/portal/computers/activate']">Activate GO-Global on a computer</a></li>
    <li>Change a computer's license</li>
    <li>Get a link to a computer</li>
    <li>Publish applications from a computer</li>
    <li>View and manage a computer's sessions</li>
    <li>Change a computer's settings</li>
</ul>